import React from 'react';
import styled from 'styled-components';
import { HeaderLogo } from '@zimpel/common/components/Logo';
import t from '@zimpel/common/helpers/i18n';
import { AppLink } from '@zimpel/common/components/Links';

const EnvironmentTagWrapper = styled.div`
  position: relative;
`;

const EnvironmentTag = styled.div`
  position: absolute;
  top: -12px;
  left: 150px;
  font-size: var(--font-size-h2);
  white-space: nowrap;
`;

const LogoContainer = styled.div`
  box-sizing: border-box;
  width: var(--navigation-width);
  padding-left: var(--screen-padding-left);
  line-height: 1;
`;

const LogoWithTag: React.FC<{ environmentTag: string | null }> = ({ environmentTag }) => (
  <>
    {environmentTag && (
      <EnvironmentTagWrapper>
        <EnvironmentTag>{environmentTag}</EnvironmentTag>
      </EnvironmentTagWrapper>
    )}
    <LogoContainer>
      <AppLink to="/">
        <HeaderLogo alt={t('product_name')} />
      </AppLink>
    </LogoContainer>
  </>
);

export default LogoWithTag;
